export default {
  API_BASE_URI: process.env.API_ROOT,
  URI_SUFFIX: {
    home: "/api/v1/user/transactions/home",
    payments: "/api/v1/user/transactions/paymentHistory",
    settledTransactions: "/api/v1/user/transactions/settled",
    paymentType: "/api/v1/user/transactions/payment/methods",
    makePayment: "/api/v1/user/transactions/payment/redirect",
    getOTP: "/api/v1/user/login",
    login: "/api/v1/user/login/verify",
    logout: "/api/v1/user/logout",
    resendOTP: "/api/v1/user/login/resend-otp/mobile",
    userProfile: "/api/v3/user/profile",
    userDetails: "/api/v1/dmi/customerDetails",
    merchants: "/api/v1/user/promotion",
    loyaltyPointStatement: "/api/v1/user/loyalty-point-statement",
    loyaltyPoints: "/api/v1/epl/statement/payment/loyaltyPoints",
    dmiStart: "/api/v1/dmi/start",
    recharge: "/recharge/",
    getBillers: "/bill/payment/fetch/billers",
    getBill: "/bill/payment/fetch/bill",
    getPaymentOptions: "/api/v1/epl/statement/getPaymentOptions",
    paymentMethods: "/api/v1/user/transactions/payment/methods",
    recentTransactions: "/api/v1/epl/statement/recent-transactions",
    getPGRedirectURL: "/api/v1/epl/statement/getPGRedirectURL",
    createTxn: "/bill/payment/create/txn",
    serviceList: "/billPayments/v1/servicesList.json",
    // userProfileV3: '/api/v3/user/profile',
    userPromotionV3: "/api/v1/user/promotion",
    // getPlans: '/recharge/Mobile/getPlans',
    // doRecharge: '/recharge/Mobile/doRecharge'
    // getPlans: '/recharge/Mobile/getPlans',
    // doRecharge: '/recharge/Mobile/doRecharge',
    mobile: "/api/v4/user/mobile",
    loginVerify: "/api/v4/user/login/verify",
    signupVerify: "/api/v4/user/signup/verify",
    personal_details: "/api/v4/user/personal-details",
    employment_details: "/api/v4/user/employment-details",
    email: "/api/v4/user/email-otp",
    verify_email_otp: "/api/v4/user/verify-email-otp",
    signup_status: "/api/v4/user/signup-status",
    emandate_methods: "/api/v1/emandate/methods",
    register_emandate: "/api/v3/user/register-emandate",
    purchase_insurance: "/api/v1/insurance/registerConsentAndRedirect/",
    getCustomerRechargeHistory: "/recharge/getCustomerRechargeHistory",
    checkRechargeStatus: "/recharge/checkRechargeStatus",
    checkBillPaymentStatus: "/bill/payment/checkBillPaymentStatus"
  },
  getEndpoint(identifier, params) {
    let URI_SUFFIX;
    switch (identifier) {
      case "home":
        URI_SUFFIX = this.URI_SUFFIX.home;
        break;
      case "payments":
        URI_SUFFIX = this.URI_SUFFIX.payments;
        break;
      case "settledTransactions":
        URI_SUFFIX = this.URI_SUFFIX.settledTransactions;
        break;
      case "paymentType":
        URI_SUFFIX = this.URI_SUFFIX.paymentType;
        break;
      case "makePayment":
        URI_SUFFIX = this.URI_SUFFIX.makePayment;
        break;
      case "getOTP":
        URI_SUFFIX = this.URI_SUFFIX.getOTP;
        break;
      case "login":
        URI_SUFFIX = this.URI_SUFFIX.login;
        break;
      case "logout":
        URI_SUFFIX = this.URI_SUFFIX.logout;
        break;
      case "resendOTP":
        URI_SUFFIX = this.URI_SUFFIX.resendOTP;
        break;
      case "userProfile":
        URI_SUFFIX = this.URI_SUFFIX.userProfile;
        break;
      case "merchants":
        URI_SUFFIX = this.URI_SUFFIX.merchants;
        break;
      case "loyaltyPointStatement":
        URI_SUFFIX = this.URI_SUFFIX.loyaltyPointStatement;
        break;
      case "loyaltyPoints":
        URI_SUFFIX = this.URI_SUFFIX.loyaltyPoints;
        break;
      case "userDetails":
        URI_SUFFIX = this.URI_SUFFIX.userDetails;
        break;
      case "dmiStart":
        URI_SUFFIX = this.URI_SUFFIX.dmiStart;
        break;
      case "getOperatorsAndRegions":
        URI_SUFFIX = `${this.URI_SUFFIX.recharge}${params}/getOperatorsAndRegions`;
        break;
      case "getPlans":
        URI_SUFFIX = `${this.URI_SUFFIX.recharge}${params}/getPlans`;
        break;
      case "doRecharge":
        URI_SUFFIX = `${this.URI_SUFFIX.recharge}${params}/doRecharge`;
        break;
      case "getBillers":
        URI_SUFFIX = this.URI_SUFFIX.getBillers;
        break;
      case "getBill":
        URI_SUFFIX = this.URI_SUFFIX.getBill;
        break;
      case "getPaymentOptions":
        URI_SUFFIX = this.URI_SUFFIX.getPaymentOptions;
        break;
      case "paymentMethods":
        URI_SUFFIX = this.URI_SUFFIX.paymentMethods;
        break;
      case "recentTransactions":
        URI_SUFFIX = this.URI_SUFFIX.recentTransactions;
        break;
      case "getPGRedirectURL":
        URI_SUFFIX = this.URI_SUFFIX.getPGRedirectURL;
        break;
      case "createTxn":
        URI_SUFFIX = this.URI_SUFFIX.createTxn;
        break;
      case "serviceList":
        URI_SUFFIX = this.URI_SUFFIX.serviceList;
        break;
      case "userProfileV3":
        URI_SUFFIX = this.URI_SUFFIX.userProfileV3;
        break;
      case "userPromotionV3":
        URI_SUFFIX = this.URI_SUFFIX.userPromotionV3;
      case "mobile":
        URI_SUFFIX = this.URI_SUFFIX.mobile;
        break;
      case "loginVerify":
        URI_SUFFIX = this.URI_SUFFIX.loginVerify;
        break;
      case "signupVerify":
        URI_SUFFIX = this.URI_SUFFIX.signupVerify;
        break;
      case "personal_details":
        URI_SUFFIX = this.URI_SUFFIX.personal_details;
        break;
      case "employment_details":
        URI_SUFFIX = this.URI_SUFFIX.employment_details;
        break;
      case "email":
        URI_SUFFIX = this.URI_SUFFIX.email;
        break;
      case "verify_email_otp":
        URI_SUFFIX = this.URI_SUFFIX.verify_email_otp;
        break;
      case "signup_status":
        URI_SUFFIX = this.URI_SUFFIX.signup_status;
        break;
      case "emandate_methods":
        URI_SUFFIX = this.URI_SUFFIX.emandate_methods;
        break;
      case "register_emandate":
        URI_SUFFIX = this.URI_SUFFIX.register_emandate;
        break;
      case "loyaltyPoints":
        URI_SUFFIX = this.URI_SUFFIX.loyaltyPoints;
        break;
      case "purchase_insurance":
        URI_SUFFIX = this.URI_SUFFIX.purchase_insurance;
        break;
      case "getCustomerRechargeHistory":
        URI_SUFFIX = this.URI_SUFFIX.getCustomerRechargeHistory;
        break;
      case "checkRechargeStatus":
        URI_SUFFIX = this.URI_SUFFIX.checkRechargeStatus;
        break;
      case "checkBillPaymentStatus":
        URI_SUFFIX = this.URI_SUFFIX.checkBillPaymentStatus;
        break;
    }
    return this.API_BASE_URI + URI_SUFFIX;
  }
};



// WEBPACK FOOTER //
// ./src/config.js